import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ItemCount from "../../../utils/ItemCount";
import DraftTable from "./DraftTable";
import RFQTable from "../RFQTable";
import axios from "axios";
import BidsTable from "../BidsTable";
import QueryTable from "./QueryTable";
import AllRFQBidTable from "../AllRFQBidTable";

const BuyerDashboard = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "PROGRESS"
  );
  const [isLoading, setIsLoading] = useState(true);
  const [rfqs, setRfqs] = useState();
  const [progressCount, setProgressCount] = useState();
  const [concludedCount, setConcludedCount] = useState();
  const [draftCount, setDraftCount] = useState();
  const [bidCount, setBidCount] = useState();
  const [queryCount, setQueryCount] = useState();
  const [rfqBidCount, setRfqBidCount] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const getProgressCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/count-all-bid?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setProgressCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getProgressCount();

    const getConcludedCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/rfq/count?username=${storedUser.username}&status=CONCLUDED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setConcludedCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getConcludedCount();

    const getBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/count?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBidCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBidCount();

    const getDraftCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft/count?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraftCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getDraftCount();

    const getQueryCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/query/count?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setQueryCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getQueryCount();

    const getRFQBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/count-bid?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setRfqBidCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getRFQBidCount();
  }, []);

  useEffect(() => {
    if (activeTab === "BIDS") {
      const getBids = async () => {
        setRfqs();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid/rfq?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getBids();
    } else if (activeTab === "QUERY") {
      const getQuery = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/query/get-rfqs?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getQuery();
    } else if (activeTab === "QUOTES") {
      const getQuotes = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid/rfq-by-bid-status?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getQuotes();
    } else if (activeTab === "PROGRESS") {
      const getAllRFQByBid = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid/rfq-by-all-status?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getAllRFQByBid();
    } else if (activeTab !== "DRAFTS") {
      const getRFQs = async () => {
        setRfqs();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/rfq?username=${storedUser.username}&status=${activeTab}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getRFQs();
    }
  }, [activeTab]);

  return (
    <Box sx={{ textAlign: "center" }}>
      {storedUser && storedUser.userRole.includes("BUYER") && (
        <Box sx={{ display: "flex", justifyContent: "end", gap: 3 }}>
          <Button
            className="btn-contained"
            sx={{ px: 5 }}
            onClick={() => navigate("/dashboard/create-rfq")}
          >
            + New RFQ
          </Button>
          <Button
            className="btn-contained"
            sx={{ px: 5 }}
            onClick={() => navigate("/dashboard/add-vendor")}
          >
            + Add Vendor
          </Button>
        </Box>
      )}

      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "PROGRESS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("PROGRESS");
                setIsLoading(true);
                localStorage.setItem("activeTab", "PROGRESS");
              }}
            >
              In Quotes
              <ItemCount count={progressCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "DRAFTS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("DRAFTS");
                setIsLoading(true);
                localStorage.setItem("activeTab", "DRAFTS");
              }}
            >
              My Drafts
              <ItemCount count={draftCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "CONCLUDED" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("CONCLUDED");
                setIsLoading(true);
                localStorage.setItem("activeTab", "CONCLUDED");
              }}
            >
              Concluded
              <ItemCount count={concludedCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "BIDS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("BIDS");
                setIsLoading(true);
                localStorage.setItem("activeTab", "BIDS");
              }}
            >
              Action Required
              <ItemCount count={bidCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "QUOTES" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("QUOTES");
                setIsLoading(true);
                localStorage.setItem("activeTab", "QUOTES");
              }}
            >
              In Recommendation
              <ItemCount count={rfqBidCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "QUERY" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("QUERY");
                setIsLoading(true);
                localStorage.setItem("activeTab", "QUERY");
              }}
            >
              Query
              <ItemCount count={queryCount} />
            </Button>
          </Box>
          {/* <Box>
            <Button
              className="pending-btn"
              onClick={() => {
                navigate("/dashboard/pending-actions");
                setActiveTab("VQ");
              }}
            >
              My Pending actions
            </Button>
          </Box> */}
        </Box>
        {activeTab === "DRAFTS" ? (
          <DraftTable />
        ) : activeTab === "BIDS" ? (
          <BidsTable
            rfqs={rfqs}
            activeTab={activeTab}
            isLoading={isLoading}
            storedUser={storedUser}
          />
        ) : activeTab === "QUERY" ? (
          <QueryTable
            rfqs={rfqs}
            activeTab={activeTab}
            isLoading={isLoading}
            storedUser={storedUser}
          />
        ) : activeTab === "PROGRESS" ? (
          <AllRFQBidTable
            rfqs={rfqs}
            activeTab={activeTab}
            isLoading={isLoading}
            storedUser={storedUser}
          />
        ) : (
          <RFQTable rfqs={rfqs} activeTab={activeTab} isLoading={isLoading} />
        )}
      </Box>
    </Box>
  );
};

export default BuyerDashboard;
